import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", () => {
    Array.from(document.querySelectorAll('.ltSingleCarouselContainer .splide')).forEach(slider => {

        const splide = new Splide( slider, {
            perPage: 6,
            perMove: 6,
            gap: 15,
            pagination: false,
            breakpoints: {
                1200: { perPage: 5, gap: 15, perMove: 5 },
                1024: { perPage: 4, gap: 15, perMove: 1 },
                900: { perPage: 4, gap: 15, perMove: 1 },
                725: { perPage: 3, gap: 15, perMove: 1, arrows: false },
                600: { perPage: 3, gap: 5, perMove: 1, arrows: false },
                500: { perPage: 2, gap: 5, perMove: 1, arrows: false },
                410: { perPage: 2, gap: 5, perMove: 1, arrows: false }
            }
        } ).mount();
    });

    Array.from(document.querySelectorAll('.ltBannerCarousel .splide')).forEach(slider => {
        const splide = new Splide( slider, { arrows: false, pagination: true, autoplay: true, interval: 5000 } ).mount();
    });
});
